import { Star } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * "Nur Favoriten · aufheben": shown while the filter is on; one tap turns it off.
 * - `float` (desktop): under the top bar.
 * - `inline` (tablets, landscape phones): in the top bar's second row.
 * - `icon` (phones): a 44 px star in the top bar's first row, named like the text chip.
 */
export function FavouriteFilterChip({
  onClear,
  variant = "float",
}: {
  onClear: () => void;
  variant?: "float" | "inline" | "icon";
}) {
  const { t } = useTranslation();
  const star = <Star aria-hidden="true" strokeWidth={1.75} fill="currentColor" />;
  if (variant === "icon") {
    return (
      <button
        type="button"
        className="map-fav-chip map-fav-chip--icon ds-btn ds-btn--icon ds-btn--glass ds-glass"
        aria-label={t("favourites.filterOff")}
        title={t("favourites.filterOff")}
        onClick={onClear}
      >
        {star}
      </button>
    );
  }
  return (
    <button
      type="button"
      className={`map-fav-chip ds-btn ds-btn--glass ds-glass${variant === "inline" ? " map-fav-chip--inline" : ""}`}
      onClick={onClear}
    >
      {star}
      {t("favourites.filterOff")}
    </button>
  );
}
